import { createSlice } from "@reduxjs/toolkit";
import { editRoleAPI } from "../../api/role";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
}; 

const editRoleSlice = createSlice({
  name: "editRole",
  initialState: data,
  reducers: {
   editRoleSlice(state) {
      state.isLoading = true;
    },
   editRoleSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    editRoleSliceFailure(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    editRoleSliceReset(state) {
      state.isLoading = false;
      state.data = null;
    },
  },
});
export const editRoleHandler = (id:any,data:any) => async (dispatch: any) => {
  try {
    dispatch(editRoleAction.editRoleSlice());
    const response: any = await editRoleAPI(id,data);
    
    dispatch(editRoleAction.editRoleSliceSuccess(response));
  } catch (e: any) {
    dispatch(editRoleAction.editRoleSliceFailure(e?.response?.data));
  }
};
export default editRoleSlice.reducer;
export const editRoleAction = editRoleSlice.actions;
